module.exports = __webpack_public_path__ + "img/bb_logo.c9cc5021.png";